@if (isEditable) {
  <coin-v2-dropdown
    #search="dropdownSearch"
    style="width: 100%"
    required
    matFormFieldClass="shadow"
    [ngModel]="getModel()"
    [disabled]="disabled"
    [dataSource]="items"
    (ngModelChange)="onSelect($event)"
    (openedChange)="onOpenedChange($event)">
    @for (item of search.results(); track item) {
      <ng-template [coinValue]="item">{{ getDisplayFn()?.(item) ?? item }}</ng-template>
    }
  </coin-v2-dropdown>
}
@if (!isEditable) {
  <p>{{ valueAsText || '' }}</p>
}
<div class="action-buttons">
  @if (canDelete && !isEditable && !disabled && data[model]) {
    <mat-icon
      class="clear"
      (click)="clear()">
      clear
    </mat-icon>
  }
  @if (!isEditable && !disabled) {
    <i
      class="edit-button material-icons"
      (click)="edit()">
      edit
    </i>
  }
</div>
